import React from 'react';
import { formatDate, formatKobo } from '../lib/utils';

const TransactionModal = ({ data: transaction }) => {
    const { id, status, amount, channel, reference, paid_at, is_local_transaction, authorization, fees, currency, type } = transaction
    const date = formatDate(paid_at, true, true)
    const { authorization_code, bank, country_code, card_type, bin, last4, exp_month, exp_year } = authorization ?? {}
    const { time_spent, attempts, errors, mobile } = transaction.log ? transaction.log : {}

    const isInvestment = authorization_code || type === "investment"
    // const isLiquidation = is_local_transaction && type === "liquidation"

    const isSuccess = status === "success"

    return (
        <div className="p-4 md:p-6">
            <div>
                <h2 className={`text-4xl font-medium mb-4 ${isInvestment ? "text-indigo-600" : "text-red-500"}`}>
                    {formatKobo(amount, isInvestment ? "N" : "-N")}
                </h2>
                <div className="space-y-1">
                    <p className="text-gray-500 text-sm font-medium uppercase tracking-wider">Reference code</p>
                    <p className="text-gray-600 truncate py-2"><span className="bg-blue-50 px-3 py-2">{reference}</span></p>
                </div>
            </div>
            <div className={`my-6 space-y-6 border-t pt-5 text-gray-600 ${!is_local_transaction && "pb-5 border-b"}`}>
                <p className="flex justify-between items-center capitalize">
                    <span>Status</span>
                    <span className={`px-5 py-1.5 rounded-full ${isSuccess ? "bg-green-100 text-green-700" : "bg-gray-100 text-gray-700"}`}>{status}</span>
                </p>
                <p className="flex justify-between items-center capitalize">
                    <span>Channel</span>
                    <span className="capitalize">{`${channel} ${card_type ? "- " + card_type.toLowerCase() : ""}`}</span>
                </p>
                <p className="flex justify-between items-center capitalize">
                    <span>Fees</span>
                    <span>{formatKobo(fees, currency)}</span>
                </p>
                <p className="flex justify-between items-center capitalize">
                    <span>Paid At</span>
                    <span>{date}</span>
                </p>
                <p className="flex justify-between items-center capitalize">
                    <span>Transaction ID</span>
                    <span>{id}</span>
                </p>
            </div>
            <div className="space-y-8">
                {
                    //don't render this on local transactions as these variables only exist on Paystack trxs
                    is_local_transaction ? null :
                        <section className="grid grid-cols-2 gap-x-3 gap-y-4">
                            <div className="space-y-1">
                                <p className="text-sm text-gray-500">Card Number</p>
                                <p className="font-medium text-gray-600">{`${bin}****${last4}`}</p>
                            </div>
                            <div className="space-y-1">
                                <p className="text-sm text-gray-500">Card Expiration</p>
                                <p className="font-medium text-gray-600">{`${exp_month} / ${exp_year}`}</p>
                            </div>
                            <div className="space-y-1">
                                <p className="text-sm text-gray-500">Authorization Code</p>
                                <p className="font-medium text-gray-600">{authorization_code}</p>
                            </div>
                            <div className="space-y-1">
                                <p className="text-sm text-gray-500">Bank and Country</p>
                                <p className="font-medium text-gray-600">{`${bank} (${country_code})`}</p>
                            </div>
                        </section>
                }
                {
                    is_local_transaction ? null :
                        <div className="text-gray-400 text-center text-sm">
                            <p className="title">{time_spent ?? 0} seconds spent on page</p>
                            <p className="title">{attempts ?? 0} attempts, {errors ?? 0} errors, on {mobile ? "mobile" : "desktop"} device</p>
                        </div>
                }
            </div>
        </div>
    );
}

export default TransactionModal;


// constD= {
//     "id": 699362068,
//     "domain": "test",
//     "status": "success",
//     "reference": "f3d13803-23db-55e0-a8e3-82f5acbbb255",
//     "amount": 10000000,
//     "message": null,
//     "gateway_response": "Approved",
//     "paid_at": "2020-05-31T00:00:10.000Z",
//     "created_at": "2020-05-31T00:00:08.000Z",
//     "channel": "card",
//     "currency": "NGN",
//     "ip_address": null,
//     "metadata": {
//         "invoice_action": "update"
//     },
//     "log": null,
//     "fees": 160000,
//     "fees_split": null,
//     "customer": {
//         "id": 24413255,
//         "first_name": "Edward",
//         "last_name": "Hussein",
//         "email": "johndoe@email.com",
//         "phone": "",
//         "metadata": {
//             "investment_start_date": "2018-04-24"
//         },
//         "customer_code": "CUS_g6hgv7c9x43z3er",
//         "risk_action": "default"
//     },
//     "authorization": {
//         "authorization_code": "AUTH_f69ae551v6",
//         "bin": "408408",
//         "last4": "0409",
//         "exp_month": "12",
//         "exp_year": "2020",
//         "channel": "card",
//         "card_type": "visa DEBIT",
//         "bank": "Test Bank",
//         "country_code": "NG",
//         "brand": "visa",
//         "reusable": true,
//         "signature": "SIG_sLNqsOpk57VmyOp0qvmr",
//         "account_name": null
//     },
//     "plan": {},
//     "subaccount": {},
//     "order_id": null,
//     "paidAt": "2020-05-31T00:00:10.000Z",
//     "createdAt": "2020-05-31T00:00:08.000Z",
//     "requested_amount": 10000000
// }